import * as React from 'react';

import {react2panel} from 'common/util/react2panel';

import {WarningHeroReact} from './index';
import {NoDataReason, WarningHeroReportName, WarningHeroTheme} from './constants';

export type NoDataHeroProps = {
  bodyText?: string;
  reportName: WarningHeroReportName;
  reason?: NoDataReason;
};

export type NoDataHeroJsxProps = {
  props: NoDataHeroProps;
};

export function NoDataHeroReact(props: NoDataHeroProps) {
  let headerText = `We couldn't find any data for your query.`;

  if (props.reason === NoDataReason.EmptyProject) {
    headerText = `We don't have any data for your project.`;
  } else if (props.reason === NoDataReason.Timeout) {
    headerText = `Sorry, the query timed out.`;
  }

  return (
    <WarningHeroReact
      theme={WarningHeroTheme.NoData}
      headerText={headerText}
      report={props.reportName}
      bodyText={props.bodyText || ``}
    />
  );
}

export const NoDataHeroPanel = react2panel(`mp-no-data-hero`, NoDataHeroReact);
